export default function Icon({
    icon,
    size = 20,
    className = "text-2xl",
    onClick,
    onKeyDown,
    ariaLabel,
    disabled = false,
    ref,
}) {
    if (!icon) return null;

    const parts = icon.split(" ");
    const interactive = typeof onClick === "function";
    const handleKeyDown = (event) => {
        onKeyDown?.(event);
        if (event.defaultPrevented || disabled || !interactive) return;
        if (["Enter", " "].includes(event.key)) {
            event.preventDefault();
            onClick(event);
        }
    };
    const interactiveProps = interactive ? {
        role: "button",
        tabIndex: disabled ? -1 : 0,
        "aria-label": ariaLabel,
        "aria-disabled": disabled,
        onClick: disabled ? undefined : onClick,
        onKeyDown: handleKeyDown,
    } : {};
    const interactionClassName = interactive
        ? disabled ? "opacity-50 cursor-default" : "cursor-pointer"
        : "";
    const commonProps = {
        ref,
        className: `z-icon ${className} ${interactionClassName}`,
        style: {fontSize: size},
        ...interactiveProps,
    };

    if (parts.includes("mi")) {
        const materialToken = parts.find((part) => part.startsWith("mi:"));
        const iconName = materialToken ? materialToken.replace("mi:", "") : "";
        return <i {...commonProps} className={`z-icon mi ${className} ${interactionClassName}`} data-icon={iconName}/>;
    }

    if (parts.includes("pi") || parts.includes("fa")) {
        return <i {...commonProps} className={`z-icon ${icon} ${className} ${interactionClassName}`}/>;
    }

    return null;
}
